(function () {
  'use strict';
  if (!document.body.classList.contains('template-product')) return;

  /* ================================================================
     TASK 2 — Fragrance category filter tabs
     All | Vanilla | Floral | Citrus | Spice
     Limited-Edition always visible
     ================================================================ */

  var CATEGORIES = {
    'Vanilla': ['Signature N1 | P1', 'Amber Noir | P2', 'Vanilla Bean | V2', 'Vanilla Musk | V3', 'Vanilla Cream | P6'],
    'Floral': ['Sweet Rome | P4', 'Moonlight Mellow | P7', 'Lavanda Vida | P9', 'Balboa Rosa | P10'],
    'Citrus': ['Torrey Pine | P5', 'Tea Dreamer | P8', 'Citrus Vale | P11'],
    'Spice': ['Saffron Rouge | P3', 'Santal Luxe | P12']
  };

  var LIMITED_EDITION_KEYWORDS = ['Discovery Set', 'Limited Edition', 'Limited-Edition'];

  function isLimitedEdition(title) {
    return LIMITED_EDITION_KEYWORDS.some(function (kw) { return title.indexOf(kw) !== -1; });
  }

  var ALL_CATEGORY_NAMES = [];
  Object.keys(CATEGORIES).forEach(function (cat) {
    CATEGORIES[cat].forEach(function (n) { ALL_CATEGORY_NAMES.push(n); });
  });

  function isLimitedEditionBtn(btn) {
    var title = btn.dataset.value || btn.textContent.trim();
    if (ALL_CATEGORY_NAMES.indexOf(title) !== -1) return false;
    if (isLimitedEdition(title)) return true;
    var prev = btn.previousElementSibling;
    while (prev) {
      if (prev.classList.contains('product__chips-sublabel') &&
          prev.textContent.indexOf('Limited') !== -1) {
        return true;
      }
      prev = prev.previousElementSibling;
    }
    return false;
  }

  function hasFragranceVariants() {
    var buttons = document.querySelectorAll('.dynamic-variant-button');
    if (buttons.length < 3) return false;
    var allNames = [];
    Object.keys(CATEGORIES).forEach(function (cat) {
      CATEGORIES[cat].forEach(function (n) { allNames.push(n); });
    });
    var matchCount = 0;
    buttons.forEach(function (btn) {
      var title = btn.dataset.value || btn.textContent.trim();
      if (allNames.indexOf(title) !== -1 || isLimitedEdition(title)) matchCount++;
    });
    return matchCount >= 2;
  }

  function injectFilterTabs() {
    if (!hasFragranceVariants()) return;
    var variantWrapper = document.querySelector('.dynamic-variant-button');
    if (!variantWrapper) return;
    var wrapper = variantWrapper.closest('.product__controls-group.product__variants-wrapper');
    if (!wrapper) return;
    if (document.getElementById('fragrance-filter-tabs')) return;

    var tabs = document.createElement('div');
    tabs.id = 'fragrance-filter-tabs';
    tabs.className = 'fragrance-filter-tabs';
    tabs.innerHTML =
      '<button class="fragrance-filter-tab active" data-category="All">All</button>' +
      '<button class="fragrance-filter-tab" data-category="Vanilla">Vanilla</button>' +
      '<button class="fragrance-filter-tab" data-category="Floral">Floral</button>' +
      '<button class="fragrance-filter-tab" data-category="Citrus">Citrus</button>' +
      '<button class="fragrance-filter-tab" data-category="Spice">Spice</button>';

    wrapper.insertBefore(tabs, wrapper.firstChild);

    tabs.addEventListener('click', function (e) {
      var tab = e.target.closest('.fragrance-filter-tab');
      if (!tab) return;
      tabs.querySelectorAll('.fragrance-filter-tab').forEach(function (t) { t.classList.remove('active'); });
      tab.classList.add('active');
      var cat = tab.dataset.category;
      filterVariantsByCategory(cat);
    });
  }

  function filterVariantsByCategory(category) {
    var buttons = document.querySelectorAll('.dynamic-variant-button');
    var allowedNames = null;
    if (category !== 'All') {
      allowedNames = CATEGORIES[category] || [];
    }

    buttons.forEach(function (btn) {
      var title = btn.dataset.value || btn.textContent.trim();
      var limited = isLimitedEditionBtn(btn);

      if (category === 'All' || limited) {
        btn.style.display = '';
        btn.removeAttribute('data-cat-hidden');
      } else if (allowedNames && allowedNames.indexOf(title) !== -1) {
        btn.style.display = '';
        btn.removeAttribute('data-cat-hidden');
      } else {
        btn.style.display = 'none';
        btn.setAttribute('data-cat-hidden', '1');
      }
    });
  }

  /* ================================================================
     TASK 4a — Sticky ATC: show only after scrolling past main CTA
     ================================================================ */

  function initStickyCtaBehavior() {
    var stickyBar = document.querySelector('.sticky-atc-bar');
    if (!stickyBar) return;

    stickyBar.dataset.showMobile = 'true';
    stickyBar.classList.add('hidden');

    var mainSubmit = document.querySelector('.product-form__cart-submit');
    if (!mainSubmit) return;

    var userScrolled = false;
    var shouldShow = false;

    window.addEventListener('scroll', function () { userScrolled = true; }, { once: true, passive: true });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        shouldShow = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        if (shouldShow && userScrolled) {
          stickyBar.classList.remove('hidden');
        } else {
          stickyBar.classList.add('hidden');
        }
      });
    }, { threshold: 0 });

    observer.observe(mainSubmit);

    var mo = new MutationObserver(function () {
      if (!shouldShow || !userScrolled) {
        if (!stickyBar.classList.contains('hidden')) {
          stickyBar.classList.add('hidden');
        }
      }
    });
    mo.observe(stickyBar, { attributes: true, attributeFilter: ['class'] });
  }

  /* ================================================================
     INITIALIZE
     Note: Task 4b (trust signals) now uses the theme's native
     "Text list with icons" (product_callouts) block instead of
     custom-injected markup. See templates/product.json and
     the ".product__block-callouts" rules in custom.css.

     Note: The "only show this fragrance's own media" behavior (Sprint 4)
     is now handled by the theme's own native "Enable multiple variant
     media" section setting (enable_multiple_variant_media) instead of a
     custom script — main-product--default.liquid already groups
     product.media into per-variant blocks (bounded by each variant's
     assigned image) server-side, images and its first video included,
     which is more reliable than inferring it client-side.
     ================================================================ */

  function init() {
    injectFilterTabs();
    initStickyCtaBehavior();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
